import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { Loader } from "semantic-ui-react";
import _ from "underscore";

import {
   getVersions,
   getAllClaims,
   getClaimOptions,
   getUserProfilePhoto,
   getClinicList,
   getUserNotifications,
   getMHCArticlesBannerList,
   getElogConfigQuestions,
   getUserBenefitConfig,
   getUserConfigBenefit,
   getMHCArticlesBannerListHomepage,
   doReloginV3,
   generateLoginOTPEmail,
   verifyLoginOTPEmail,
   doLogout,
   getHradminMhcInsightsURL, //[ADDED BY JW]
   getAppLaunchConfigFromMHC,
   getMHCRewardsCategoryList
} from "../../actions";
import NavSidebar from "../../component/navigation/sidebar/nav_sidebar";
import NavTopbar from "../../component/navigation/topbar/nav_topbar";
import MainPage from "./main_page";
import SubmitClaimPage from "./submit_claim_page";
import ClaimRecordPage from "./claim_record_page";
import ClaimDetailOutPage from "./claim_detail_out_page";
import ClaimDetailInpPage from "./claim_detail_inp_page";
import PanelVisitPage from "./panel_visit_page";
import PanelVisitDetailPage from "./panel_visit_detail_page";
import AskJoeyPage from "./ask_joey_page";
import MarketplacePage from "./marketplace_page";
import ClaimUpdateOutPage from "./claim_update_out_page";
import ClaimUpdateInpPage from "./claim_update_inp_page";
import ClinicLocatorPage from "./clinic_locator_page";
import ProfilePage from "./profile_page";
import SubmitElogPage from "./submit_elog_page";
import EcardPage from "./ecard_page";
import HealthArticlesPage from "./health_articles_page";
import HealthArticlesViewPage from "./health_articles_view_page";
import ProductViewPage from "./product_view_page";
import ProductRedeemPage from "./product_redeem_page";
import ElogRecordPage from "./elog_record_page";
import ViewInvoicePage from './view_invoice_page'
//import TokenExpireModal from "../../component/token_expire_modal";
import RewardsCategoryPage from "./rewards_category_page";
import RewardsListPage from "./rewards_list_page";
import RewardsDetailsPage from "./rewards_details_page";
import RewardsDetailsRedeemedPage from "./rewards_details_redeemed_page";
import VerifyOtpModal from "./verify_otp_modal";
import AuthenticatorPage from "./authenticator_page";

class IndexPage extends Component {
   state = {
      showLoading: false
   }
   componentDidMount() {
      // kick user out if there is no user accessToken - Unauthorized access
      if (!this.props.user || !this.props.user.accessToken) {
         this.props.history.push("/");
      } else {
         // check if all data is loaded?
         // to run all loads on config data before displaying UI.
         // claims.data , claimOptions.inpatientClaimOptions, claimOptions.outpatientClaimOptions , user.profilePhoto
         const { claimOptions, claims, profilePhoto, claimFilterOptions, clinics } = this.props;
         const { accessToken } = this.props.user;
         console.log('this.props.user', this.props.user)
         const companyId = this.props.filterOptions.filterByCompany ? this.props.filterOptions.filterByCompany : this.props.user.companies[0].companyId
         // if (!claimOptions.inpatientClaimOptions || !claimOptions.outpatientClaimOptions) {
         //    this.props.getClaimOptions(accessToken);
         // }
         // if (claims.isLoaded === false) {
         //    this.props.getAllClaims({ claimFilterOptions, accessToken }, null);
         // }
         // if (!profilePhoto) {
         //    this.props.getUserProfilePhoto(accessToken);
         // }
         if (clinics.isLoaded === false) {
            this.props.getClinicList(accessToken, companyId);
         }
         this.props.getMHCArticlesBannerListHomepage(accessToken);
         // this.props.getElogConfigQuestions(this.props.user.nric, accessToken);
         this.props.getUserBenefitConfig({ accessToken, userId: this.props.user.uuid, companyId });
         this.props.getUserConfigBenefit({ accessToken, companyId });
         this.props.getAppLaunchConfigFromMHC();

         // Load M-Insights URL [ADDED BY JW]
         const assignedRoles = this.props.user.roles;
         const hasHrAdminRole = _.find(assignedRoles, role => role.type === "hradmin");
         if (hasHrAdminRole) {
            const { accessToken } = this.props.user;
            this.props.getHradminMhcInsightsURL({ accessToken });
         }
      }
   }

   // componentDidMount() {
   //    // kick user out if there is no user accessToken - Unauthorized access
   //    if (!this.props.user || !this.props.user.accessToken) {
   //       this.props.history.push("/");
   //    } else {
   //       setTimeout(() => {
   //          if (window.embedded_svc) {
   //             const {user} = this.props;
               
   //             window.embedded_svc.mergeSettings({
   //                prepopulatedPrechatFields: {
   //                   FirstName: user.name,
   //                   Email: user.email,
   //                   SuppliedCompany: user.companyName
   //                }
   //             });

   //             window.embedded_svc.showHelpButton();   
   //          }
   //       }, 3000);
   //       // if(!this.props.appLaunchHistory){
   //       //    this.props.setAppLaunchHistory(this.props.history.length);
   //       // }
   //       this.reload();
   //    }
   // }

   // componentWillUnmount() {
   //    if (window.embedded_svc) {
   //       window.embedded_svc.hideHelpButton();
   //    }
   // }

   componentDidUpdate(prevProps, prevState, snapshot) {
      if (!this.props.user) {
         this.props.history.push("/");
      }
   }

   // reload() {
   //    this.showLoading();
   //    // check if all data is loaded?
   //    // to run all loads on config data before displaying UI.
   //    // claims.data , claimOptions.inpatientClaimOptions, claimOptions.outpatientClaimOptions , user.profilePhoto
   //    console.log('------>>>', this.props.user, this.props.filterOptions);
   //    const { claimOptions, claims, profilePhoto, claimFilterOptions, clinics } = this.props;
   //    const { accessToken } = this.props.user;
   //    const companyId = this.props.filterOptions.filterByCompany ? this.props.filterOptions.filterByCompany : this.props.user.companies[0].companyId

   //    // if (!claimOptions.inpatientClaimOptions || !claimOptions.outpatientClaimOptions) {
   //    //    this.props.getClaimOptions(accessToken, companyId);
   //    // }
   //    // if (claims.isLoaded === false) {
   //    //    this.props.getAllClaims({ claimFilterOptions, accessToken, companyId }, null);
   //    // }
   //    // if (!profilePhoto) {
   //    //    this.props.getUserProfilePhoto(accessToken);
   //    // }
   //    if (clinics.isLoaded === false) {
   //       this.props.getClinicList(accessToken, companyId);
   //    }
   //    this.props.getMHCArticlesBannerListHomepage(accessToken);
   //    // this.props.getElogConfigQuestions(this.props.user.nric, accessToken);
   //    this.props.getUserBenefitConfig({ accessToken, userId: this.props.user.uuid, companyId });
   //    this.props.getUserConfigBenefit({ accessToken, companyId }).then(() => this.setState({showLoading: false}));
      
   //    // Load M-Insights URL [ADDED BY JW]
   //    const assignedRoles = this.props.user.roles;
   //    const hasHrAdminRole = _.find(assignedRoles, role => role.type === "hradmin");
   //    if (hasHrAdminRole) {
   //       const { accessToken } = this.props.user;
   //       this.props.getHradminMhcInsightsURL({ accessToken });
   //    }
   // }

   // showLoading(){
   //    this.setState({
   //       showLoading: true
   //    })
   // }


   render() {
      // const { claimOptions, claims, profilePhoto } = this.props;
      // if (
      //    !claimOptions.inpatientClaimOptions ||
      //    !claimOptions.outpatientClaimOptions ||
      //    claims.isLoaded === false ||
      //    !profilePhoto
      // ) {
      //    return <Loader active />;
      // }
      return (
         <div>
             {/* <TokenExpireModal
                user={this.props.user}
                doLogin={this.props.doReloginV3}
                doLogout={this.props.doLogout}
                generateLoginOTPEmail={this.props.generateLoginOTPEmail}
                verifyLoginOTPEmail={this.props.verifyLoginOTPEmail}
                tokenHasExpired={this.props.tokenHasExpired}
             /> */}
            {!this.props.isVerified &&
            <VerifyOtpModal
                user={this.props.user}
                generateLoginOTPEmail={this.props.generateLoginOTPEmail}
                verifyLoginOTPEmail={this.props.verifyLoginOTPEmail}
                isVerified={this.props.isVerified}
                OTPtype={this.props.configBenefit &&  this.props.configBenefit.featuresConfig && this.props.configBenefit.featuresConfig.OTPtype  ? this.props.configBenefit.featuresConfig.OTPtype : "EMAIL"}
             />}
            <div
               style={{
                  position: "fixed",
                  width: 250,
                  backgroundColor: "#FFFFFF",
                  zIndex: 995,
                  top: 0,
                  bottom: 0,
                  padding: 20
               }}
            >
            {this.props.configBenefit &&  this.props.configBenefit.featuresConfig && 
               <NavSidebar
                  configBenefit={this.props.configBenefit}
                  currentPath={this.props.location.pathname}
                  assignedRoles={this.props.user && this.props.user.roles}
                  user={this.props.user}
                  minsightsUrl={this.props.mhcInsightsUrl} //[ADDED BY JW]
               />}
            </div>
            <div
               style={{
                  position: "fixed",
                  width: "100%",
                  zIndex: 990,
                  backgroundColor: "#F6F9FA",
                  height: 60,
                  paddingLeft: 250
               }}
            >
               <NavTopbar
                  user={this.props.user}
                  profilePhoto={this.props.profilePhoto}
                  getUserNotifications={this.props.getUserNotifications}
                  userHasUnreadMessages={this.props.userHasUnreadMessages}
               />
            </div>
            <div style={{ display: "block", width: "100%", paddingLeft: 250 }}>
               <div
                  style={{
                     position: "relative",
                     display: "inline-block",
                     marginTop: 60,
                     width: "100%",
                     minHeight: 768,
                     height: "100%",
                     backgroundColor: "#F6F9FA",
                     padding: "0px 20px"
                  }}
               >
                  <Switch>
                     <Route exact path="/app" component={MainPage} />
                     <Route path="/app/authenticator" component={AuthenticatorPage} />
                     <Route path="/app/submitclaim" component={SubmitClaimPage} />
                     <Route path="/app/ecards" component={EcardPage} />
                     <Route path="/app/claimrecords/inp/:claimTransactionNo/update" component={ClaimUpdateInpPage} />
                     <Route path="/app/claimrecords/inp/:claimTransactionNo/:claimStatus" component={ClaimDetailInpPage} />
                     <Route path="/app/claimrecords/inp/:claimTransactionNo" component={ClaimDetailInpPage} />
                     <Route path="/app/claimrecords/inp" component={ClaimDetailInpPage} />
                     <Route path="/app/claimrecords/out/:claimTransactionNo/update" component={ClaimUpdateOutPage} />
                     <Route path="/app/claimrecords/out/:claimTransactionNo/:claimStatus" component={ClaimDetailOutPage} />
                     <Route path="/app/claimrecords/out/:claimTransactionNo" component={ClaimDetailOutPage} />
                     <Route path="/app/claimrecords/out" component={ClaimDetailOutPage} />
                     <Route path="/app/claimrecords" component={ClaimRecordPage} />
                     <Route path="/app/visits/:visitNo/:visitId" component={PanelVisitDetailPage} />
                     <Route path="/app/visits" component={PanelVisitPage} />
                     <Route path="/app/askjoey" component={AskJoeyPage} />
                     <Route path="/app/store" component={MarketplacePage} />
                     <Route path="/app/product/view" component={ProductViewPage} />
                     <Route path="/app/product/redeem" component={ProductRedeemPage} />
                     <Route path="/app/product/invoice" component={ViewInvoicePage} />
                     <Route path="/app/cliniclocator" component={ClinicLocatorPage} />
                     <Route path="/app/profile" component={ProfilePage} />
                     <Route path="/app/elogrecords" component={ElogRecordPage} />
                     <Route path="/app/submitelog" component={SubmitElogPage} />
                     <Route path="/app/healtharticles/view" component={HealthArticlesViewPage} />
                     <Route path="/app/healtharticles" component={HealthArticlesPage} />
                     <Route path="/app/rewards/:category/details/:rewardId/redeemed" component={RewardsDetailsRedeemedPage} />
                     <Route path="/app/rewards/:category/details/:rewardId" component={RewardsDetailsPage} />
                     <Route path="/app/rewards/:category/:categoryname" component={RewardsListPage} />
                     <Route path="/app/rewards" component={RewardsCategoryPage} />
                  </Switch>
               </div>
            </div>
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      versions: state.versions,
      user: state.user.user,
      configBenefit: state.user.configBenefit,
      profilePhoto: state.user.profilePhoto,
      claims: state.claims,
      claimOptions: state.claimOptions,
      claimFilterOptions: state.claims.filterOptions,
      clinics: state.clinics,
      userHasUnreadMessages: state.user.hasUnreadMessages,
      userNotifications: state.user.notifications,
      tokenHasExpired: state.user.tokenHasExpired,
      mhcInsightsUrl: state.hradmin.mhcInsightsUrl, //[ADDED BY JW]
      filterOptions: state.clinics.filterOptions,
      isVerified: state.otp.isVerified,
      appLaunchHistory: state.appConfig.appLaunchHistory,
      errorBenefits: state.user.errorBenefits,
   };
}

export default connect(
   mapStateToProps,
   {
      getVersions,
      getAllClaims,
      getClaimOptions,
      getUserProfilePhoto,
      getClinicList,
      getUserNotifications,
      getMHCArticlesBannerList,
      getMHCArticlesBannerListHomepage,
      getElogConfigQuestions,
      getUserBenefitConfig,
      getUserConfigBenefit,
      doReloginV3,
      generateLoginOTPEmail,
      verifyLoginOTPEmail,
      doLogout,
      getHradminMhcInsightsURL, //[ADDED BY JW]
      getAppLaunchConfigFromMHC,
      getMHCRewardsCategoryList
   }
)(IndexPage);

/*
<div style={{
    position: 'relative', display: 'inline-block', marginTop: 60, width: '100%', minHeight: 1024, height: '100%', backgroundColor: '#F6F9FA', padding: '0px 20px'
}}>
*/
